/** Internal dependencies */
import { prepareApiCall } from './prepareApiCall';

export function handleDropdownFilters(e) {
    e.preventDefault();

    if (!e.target.matches('[type="checkbox"], [type="radio"]')) {
        return false;
    }

    const parent = e.target.closest('[data-rest]');

    // here will come the logic to add the selected filters to the filter status bar
    const activeFiltersContainer = parent.querySelector('[data-filters-active]');

    if (activeFiltersContainer) {
        const filter = e.target;
        const isActive = filter.checked;

        if (isActive) {
            const icon = document.createElement('span');
            icon.classList.add('pill-icon', 'ms-2', 'd-inline-flex', 'align-items-center', 'justify-content-center');
            icon.innerHTML = '<i class="fal fa-times"></i>';
            const pill = document.createElement('button');
            pill.classList.add(
                'badge',
                'rounded-pill',
                'd-inline-flex',
                'align-items-center',
                'justify-content-center',
                'py-0',
                'bg-primary',
                'border-0',
                'mx-2',
                'mt-3'
            );
            pill.setAttribute('type', 'button');
            pill.dataset.filterTaxonomy = filter.name;
            pill.dataset.filterTerm = filter.value;
            pill.textContent = filter.nextElementSibling.textContent;
            pill.appendChild(icon);

            if (filter.type === 'radio') {
                // remove potentially existing pills of same taxonomy
                const existingPill = activeFiltersContainer.querySelector(`[data-filter-taxonomy="${filter.name}"]`);
                if (existingPill) {
                    existingPill.remove();
                }
            }
            activeFiltersContainer.appendChild(pill);
        } else {
            const existingPill = activeFiltersContainer.querySelector(
                `[data-filter-taxonomy="${filter.name}"][data-filter-term="${filter.value}"]`
            );
            if (existingPill) {
                existingPill.remove();
            }
        }
    }

    if (!parent) {
        return;
    }

    prepareApiCall(parent);
}
